import { observer } from "mobx-react"
import { Col, Form, Row, Select } from "antd"

import { InputPattern } from "@src/app/components/InputPattern"
import { GlobalCurrenciesCollection } from "@src/app/CurrenciesCollection"
import {
  floatValidator,
  USDPricePattern,
  zeroValidator,
} from "@src/app/validators"

export const PaymentLinkFormAmount = observer(() => {
  const currencies = GlobalCurrenciesCollection()

  return (
    <Row gutter={30}>
      <Col span={14}>
        <Form.Item
          id="GENERATED_ID_PAYMENTLINKFORMAMOUNT_TSX_FORM.ITEM_VOID_1"
          initialValue=""
          label="Amount"
          name={"fiat_price"}
          rules={[
            {
              message: "Please input amount",
              required: true,
              validator: floatValidator,
            },
            {
              message: "Amount should be greater than 0",
              required: true,
              validator: zeroValidator,
            },
          ]}
        >
          <InputPattern pattern={USDPricePattern} placeholder="Enter price" />
        </Form.Item>
      </Col>
      <Col span={10}>
        <Form.Item
          id="GENERATED_ID_PAYMENTLINKFORMAMOUNT_TSX_FORM.ITEM_VOID_2"
          label="Currency"
          name="symbol"
          rules={[{ message: "Please select at least one", required: true }]}
        >
          <Select
            options={currencies.selectOptionsFiat}
            placeholder="Select currency"
          />
        </Form.Item>
      </Col>
    </Row>
  )
})
